export const FLAG_GETTING_COMPANY_RESOURCE_GROUPS =
  'FLAG_GETTING_COMPANY_RESOURCE_GROUPS';
export const GET_COMPANY_RESOURCE_GROUPS = 'GET_COMPANY_RESOURCE_GROUPS';
export const CLEAR_COMPANY_RESOURCE_GROUPS = 'CLEAR_COMPANY_RESOURCE_GROUPS';
export const FLAG_COMPANY_RESOURCE_GROUP_ACTIVITY =
  'FLAG_COMPANY_RESOURCE_GROUP_ACTIVITY';
export const GET_COMPANY_RESOURCE_GROUP = 'GET_COMPANY_RESOURCE_GROUP';
export const CLEAR_COMPANY_RESOURCE_GROUP = 'CLEAR_COMPANY_RESOURCE_GROUP';
